import React, { createContext, useState, useContext, useEffect } from 'react';
import { PersonProjects } from '../models/user.model';
import useUser from '../hooks/useUser';

interface ProjectContextType {
  selectedProject: string
  setSelectedProject: (project: string) => void
  projectsList: PersonProjects[]
  setProjectsList: (projects: PersonProjects[]) => void
  isProjectUndefined: () => boolean
}

const ProjectContext = createContext<ProjectContextType | undefined>(undefined);

export const useProject = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProject must be used inside a ProjectProvider');
  }
  return context;
};

export const ProjectProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useUser()

  const [selectedProject, setSelectedProject] = useState<string>(
    localStorage.getItem('selectedProject') || 'ALL'
  );

  const [projectsList, setProjectsList] = useState<PersonProjects[]>(
    JSON.parse(localStorage.getItem('projectsList') || '[]')
  )

  const isProjectUndefined = () => selectedProject === '' || selectedProject === 'ALL'

  useEffect(() => {
    localStorage.setItem('selectedProject', selectedProject);
  }, [selectedProject])

  useEffect(() => {
    localStorage.setItem('projectsList', JSON.stringify(projectsList));
  }, [projectsList.length])


  return (
    <ProjectContext.Provider value={{
      selectedProject,
      setSelectedProject,
      projectsList,
      setProjectsList,
      isProjectUndefined
    }}>
      {children}
    </ProjectContext.Provider>
  );
};
